import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-11">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-light/30 -skew-x-12 translate-x-20" data-id="element-12" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-15">
            <div className="relative aspect-[4/5] max-w-md mx-auto lg:mx-0 z-10" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/bwoGaU7YwwSGtruPx8tgWN/Shazz_Browne_Mendez_Profile_Pic.jpg" alt="Shazz Browne Mendez" className="w-full h-full object-cover shadow-2xl" data-id="element-17" />
              {/* Decorative frame */}
              <div className="absolute -inset-4 border-2 border-brand-gold/30 -z-10 translate-x-4 translate-y-4" data-id="element-18" />
              <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-brand-purple rounded-full blur-3xl opacity-20 -z-20" data-id="element-19" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-20">
            <h2 className="text-brand-purple font-semibold tracking-widest uppercase text-sm mb-3" data-id="element-21">
              The Artist Behind the Chair
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6 leading-tight" data-id="element-22">
              Meet Shazz
            </h3>
            <div className="space-y-6 text-gray-600 font-light text-lg leading-relaxed" data-id="element-23">
              <p data-id="element-24">
                With over a decade of experience in the high-fashion and
                celebrity styling world, Shazz brings an unparalleled level of
                artistry and precision to every client who sits in her chair.
              </p>
              <p data-id="element-25">
                Known for her transformative color techniques, flawless
                extensions, and signature glamorous blowouts, she believes that
                hair is your ultimate accessory. Whether you're preparing for a
                red carpet event, a wedding, or simply want to elevate your
                everyday look, Shazz crafts styles that turn heads and boost
                confidence.
              </p>
              <p className="font-medium text-brand-purple" data-id="element-26">
                "Every client deserves to feel like a star. My goal is to bring
                out the absolute best version of you."
              </p>
            </div>

            <div className="mt-10" data-id="element-27">
              <img src="https://cdn.magicpatterns.com/uploads/5ehSxxLNge9mVEnk9GFcym/Glitzz_by_Shazz_Logo.png" alt="Glitzz Signature" className="h-12 opacity-40 grayscale" data-id="element-28" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}